import React from "react";

export default function Footer() {
    return (
        <footer>
            <p>Proyecto de Germán Mansilla</p>
        </footer>
    )
}